import React from "react";

export const ArrowSort = ({ width = 24, height = 24, color = "#ffffff" }) => {
    return (
        <svg width={`${width}px`} height={`${height}px`} viewBox="0 0 24 24" strokeWidth="1.5" fill="none" xmlns="http://www.w3.org/2000/svg" color={color}>
            <path d="M17 8L12 3L7 8" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
            <path d="M17 16L12 21L7 16" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
        </svg>)
}